import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const getSettings = async () => {
  try {
    const PropertyDynamicFieldsDoc = await doc(
      db,
      "clients",
      getLocalStorageItem("bid"),
      "dynamicFields",
      "settings"
    );

    const settings = (await getDoc(PropertyDynamicFieldsDoc)).data() || {};

    settings.currencyFormat = settings.currencyFormat || "verbal";
    settings.currency = settings.currency || "PKR";
    settings.country = settings.country || "Pakistan";
    return settings;
  } catch (error) {
    console.log(error);
    return {
      currencyFormat: "verbal",
      currency: "PKR",
      country: "Pakistan",
    };
  }
};

export default getSettings;
